const methodologyMatchMedia = gsap.matchMedia()

methodologyMatchMedia.add({
    isDesktop: "(min-width: 641px)",
    isMobile: "(max-width: 640px)",
}, (context) => {
    const { isDesktop, isMobile } = context.conditions;
    const getTransformPropertyValue = (x, y, s) => `translate(${x}%,${y}%) scale(${s})`
    
    context.add("animateMethodology", () => {
        /**
         * !! IMPORTANT
         * The order in which these animations are written is important,
         * each .fromTo sets an initial state so the last animation has to be the first in order to have the intended result
         */
        
        // updates first image scale on scroll to first step
        gsap.fromTo(".methodology-steps-images .base-image", {
            transform: getTransformPropertyValue(0, 0, 1),
        }, {
            scrollTrigger: {
                trigger: ".methodology-step.base-step",
                start: "top top",
                endTrigger: ".methodology-step.first-step",
                end: "top top",
                scrub: true,
            },
            transform: getTransformPropertyValue(50, 0, 1.5)
        })

        // scales back second image on scroll to third step
        gsap.fromTo(".methodology-steps-images .second-step-image ", {
            transform: getTransformPropertyValue(37.5, 0, 1.5)
        }, {
            scrollTrigger: {
                trigger: ".methodology-step.second-step",
                start: "top top",
                endTrigger: ".methodology-step.third-step",
                end: "top top",
                scrub: true,
            },
            immediateRender: false,
            transform: getTransformPropertyValue(0, isDesktop ? -10 : -5, 1)
        })

        // hides second image and reveals third image
        gsap.timeline({
            scrollTrigger: {
                trigger: ".methodology-step.third-step",
                start: "top 25%",
                end: "bottom top",
                toggleActions: "play none non reverse",
            }
        })
        .fromTo(".methodology-steps-images .second-step-image", { opacity: 1 }, { opacity: 0 })
        .fromTo(".methodology-steps-images .third-step-image", { opacity: 0 }, { opacity: 1 }, "<")

        // hides first image and reveals second image
        gsap.timeline({
            scrollTrigger: {
                trigger: ".methodology-step.second-step",
                start: "top center",
                end: "bottom top",
                toggleActions: "play none non reverse",
            }
        })
        .fromTo(".methodology-steps-images .first-step-image", { xPercent: 0, opacity: 1 }, { xPercent: -12.5, opacity: 0 }, "<")
        .fromTo(".methodology-steps-images .second-step-image", { opacity: 0 }, { opacity: 1 }, "<")

        // hides base image and reveals first image
        gsap.timeline({
            scrollTrigger: {
                trigger: ".methodology-step.first-step",
                start: "top center",
                end: "bottom top",
                toggleActions: "play none non reverse",
            }
        })
        .fromTo(".methodology-steps-images .base-image", { opacity: 1 }, { opacity: 0 })
        .fromTo(".methodology-steps-images .first-step-image", { opacity: 0 }, { opacity: 1 }, "<")
    });

    context.animateMethodology();
    document.addEventListener("shopify:section:load", context.animateMethodology);

    return () => {
        document.removeEventListener("shopify:section:load", context.animateMethodology)
    }
});